import React, { useState, useEffect } from "react";
import { EventApplicationService, InvoiceService } from "../../../services";
import { AuthService } from "../../../services";
import ReactPaginate from "react-paginate";
import { Table } from "react-bootstrap";
import { formatDateENGB, handleConsoleError } from "../../../utils/common-methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { globalConstant } from "../../../constants/globalConstant";
import { ApplicationStatus } from "../../../constants/Enum";
import { toast } from "react-toastify";
const html2pdf = require("html2pdf.js");
//import _ from "lodash";

const EventCatererSubmissionList = (props) => {
  const { eventId } = useParams();
  const loginUser = AuthService.getLoginUser();

  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  //const [invoicebyId, setInvoiceById] = useState();
  //const [detailsInvoice, setDetailsInvoice] = useState();
  const [formValue, setFormvalues] = useState();
  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getEventData();
  }, []);

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventApplicationService.getSubmitterCatererAppByEventId(
          eventId
        );
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data);
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleView = async (id, name) => {
    try {
      navigate(
        routes.SUBMISSION_CATERER_DETAILS.replace(":eventId", eventId).replace(
          ":appId",
          id
        )
      );
    } catch (error) {}
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const getObscuredTextLabel = (isApproved, text) => {
    return !isApproved ? text : "*************";
  };
  const getObscuredText = (isApproved) => {
    return isApproved ? { filter: "blur(4px)" } : {};
  };
  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };
  // ******************************************

  const onSubmit = async (eventId) => {
    try {
      let Invoicebyid = {};
      const InvoiceByid = await InvoiceService.getInvoiceByApplicationId(
        eventId
      );
      if (InvoiceByid?.isSuccess) {
        // setInvoiceById(InvoiceByid.data);
        Invoicebyid = InvoiceByid?.data;
      }

      let DetailsInvoice = {};
      const InvoiceDetaislByid = await InvoiceService.getInvoiceDetailsById(
        eventId
      );
      if (InvoiceByid?.isSuccess) {
        // setDetailsInvoice(InvoiceDetaislByid.data);
        DetailsInvoice = InvoiceDetaislByid?.data;
      }

      const updatedFormValues = {
        ...formValue,
        Invoicebyid,
        DetailsInvoice,
      };

      setFormvalues(updatedFormValues);
      InvoicePdf(updatedFormValues);
    } catch (error) {
      handleConsoleError(error);
    }
  };

  //******  Invoice PDF CODE *****************
  const InvoicePdf = async (formValue) => {
    try {
      //const nestedArr = formValue;

      let html = globalConstant.InvoiceHTML;
      html = html
        .toString()
        .replace(
          "@componyName@",
          formValue?.businessName ?? ""
        )
        .replace(
          "@vat@",
          formValue?.Invoicebyid.vat ?? ""
        )
        .replace(
          "@invoiceNo@",
          formValue?.Invoicebyid?.invoiceNo ?? ""
        )
        .replace(
          "@address@",
          formValue?.Invoicebyid?.city ?? ""
        )
        .replace(
          "@invoiceAddress@",
          formValue?.Invoicebyid?.invoiceAddress ?? ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.Invoicebyid?.businessLogoUrl ?? ""
        )
        .replace(
          "@eventName@",
          formValue?.Invoicebyid?.eventName ?? ""
        )
        .replace(
          "@organiserLegalBusinessName@",
          formValue?.Invoicebyid?.organiserLegalBusinessName?? ""
        )
        .replace(
          "@organiserLegalBusinessName@/g",
          formValue?.Invoicebyid?.organiserLegalBusinessName??  ""
        )
        .replace(
          "@organiserAddress@",
          formValue?.Invoicebyid?.organiserAddress ??  ""
        )
        .replace(
          "@traderLegalBusinessName@",
          formValue?.Invoicebyid?.traderLegalBusinessName ?? ""
        )
        .replace(
          "@invoiceDate@",
          formValue?.Invoicebyid?.invoiceDate ??  ""
        )
        .replace(
          "@traderAddress@",
          formValue?.Invoicebyid?.traderAddress?? ""
        )

        //Table
        .replace(
          "@balanceDue@",
          formValue?.DetailsInvoice?.balanceDue
            ??""
        )
        .replace(
          "@litterBond@",
          formValue?.DetailsInvoice?.litterBond
            ?? ""
        )
        .replace(
          "@shipping@",
          formValue?.DetailsInvoice?.shipping
            ?? ""
        )
        .replace(
          "@tax@",
          formValue?.DetailsInvoice.tax ?? ""
        )
        .replace(
          "@subTotal@",
          formValue?.DetailsInvoice?.subTotal
            ?? ""
        )

        // Table
        .replace(
          " @table@",
          (formValue?.DetailsInvoice?.objInvoiceDetailListViewModel ?? [])
            .map(
              (msd) =>
                `<tr>
                  <td  >${msd?.qty ?? "-"}</td>
                  <td >${msd?.item ??  "-"}</td>
                  <td >${msd?.description ?? "-"}</td>
                  <td >${msd?.discount ?? "-"}</td>
                   <td>${msd?.taxable === true ? "Yes" : "No"}</td>
                    <td >${msd?.unitPrice ?? "-"}</td>
                    <td >${msd?.total ??  "-"}</td>
            </tr> `
            )
            .join("")
        );

      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Caters_Invoice.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 150,
          scale: 4,
          letterRendering: true,
          useCORS: true,
          // scrollY: 2,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
          before: ".nextpage1",
        },
      };

      html2pdf()
        .set(opt)
        .from(html)
        .toPdf()
        .get("pdf")
        .then(function() {})
        .save();
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Pitch Name</th>
                  <th>Caterer Name</th>
                  <th>On Site Contact </th>
                  <th>Pay Out Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.pitchName}</td>

                          <td
                            style={getObscuredText(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true
                            )}
                          >
                            {getObscuredTextLabel(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true,
                              item?.traderName
                            )}
                          </td>
                          <td
                            style={getObscuredText(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true
                            )}
                          >
                            {getObscuredTextLabel(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true,
                              item?.onSiteContact
                            )}
                          </td>
                          <td>
                            {item.payOutDate
                              ? formatDateENGB(item?.payOutDate)
                              : "NA"}
                          </td>
                          <td>{item?.statusName}</td>
                          <td>
                            <div className="delete-create">
                              <Link
                                title="View Application"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleView(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                              <a
                                href={
                                  item?.traderProfileUrl +
                                  "trader-profile-organizer-caterer"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Trader Profile"
                              >
                                <i className="fa fa-user-circle"></i>
                              </a>
                              {/* <Link
                                to={`${routes.TRADER_PROFILE.replace(
                                  ":id",
                                  item?.traderId
                                ).replace(
                                  ":eventUrl",
                                  "trader-profile-organizer"
                                )}`}
                              >
                                <i className="fa fa-user-circle"></i>
                              </Link> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventCatererSubmissionList);
